module.exports = __webpack_public_path__ + "img/re_IMG_1230.a7e2e394.jpeg";